import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PAUSE_RESUME_STATUSES } from 'constants/resumePause';
import {
  updateStopResumeModalTitle,
  updateStopResumeOrders,
} from 'redux/actions/providers';
import useCountDown from 'components/PauseResume/useCountDown';
import { selectIsMev3BrandLoading } from 'redux/selectors';

const useResumePauseActions = (modalTitle, providerAll, isOpen) => {
  const dispatch = useDispatch();

  const { stopResumeOrders } = useSelector(({ providers }) => providers);
  const isBrandLoading = useSelector(selectIsMev3BrandLoading);

  const { statuses } = stopResumeOrders;
  const { status } = statuses;

  const { duration } = useCountDown(statuses, () => {
    return dispatch(
      updateStopResumeOrders({
        ...stopResumeOrders,
        data: {
          ...stopResumeOrders.data,
          action: PAUSE_RESUME_STATUSES.RECEIVING,
        },
        statuses: {
          ...stopResumeOrders.statuses,
          paused_until: '',
          status: PAUSE_RESUME_STATUSES.RECEIVING,
        },
      })
    );
  });

  const statusStyle = useMemo(() => {
    const upperStatus = status?.toUpperCase();
    const isBusy =
      statuses?.details?.some(
        (item) => item?.provider_status === PAUSE_RESUME_STATUSES.BUSY
      ) || status === PAUSE_RESUME_STATUSES.BUSY;

    const isActive =
      status === PAUSE_RESUME_STATUSES.ACCEPTING ||
      status === PAUSE_RESUME_STATUSES.RECEIVING

    if (isBusy && (status === PAUSE_RESUME_STATUSES.ACCEPTING ||
       status === PAUSE_RESUME_STATUSES.RECEIVING)) {
      return {
        backgroundColor: '#FF8A00',
        borderColor: '#FF8A00',
        statusName: 'ACCEPTING',
      };
    }

    if (status === PAUSE_RESUME_STATUSES.PARTIALLY_ACCEPTING) {
      return {
        backgroundColor: 'linear-gradient(to right, #FF8A00 50%, rgba(255, 255, 255, 1) 50%)',
        borderColor: '#FF8A00',
        statusName: upperStatus,
      };
    }

    if (isActive && !isBusy) {
      return {
        backgroundColor: 'green',
        borderColor: 'green',
        statusName: PAUSE_RESUME_STATUSES.ACCEPTING,
      };
    }

    if (status === PAUSE_RESUME_STATUSES.BUSY) {
      return {
        backgroundColor: '#FF8A00',
        borderColor: '#FF8A00',
        statusName: upperStatus,
      };
    }
    if (status === PAUSE_RESUME_STATUSES.NA) {
      return {
        backgroundColor: 'gray',
        borderColor: 'gray',
        statusName: upperStatus,
      };
    }

    return {
      backgroundColor: 'red',
      borderColor: 'red',
      statusName: upperStatus,
    };
  }, [status, statuses?.details]);


  const handleShowResumePause = () => {
    if (!duration) return;
    if (isOpen) {
      dispatch(
        updateStopResumeOrders({ showModal: true, provider: providerAll })
      );
      dispatch(updateStopResumeModalTitle(modalTitle));
    }
  };

  return { 
		handleShowResumePause,
		statusStyle,
		duration,
	  isBrandLoading,
	  stopResumeOrders
   };
};

export default useResumePauseActions;